import React from 'react';

import { appFormUtil } from 'modules/common';

import { useRemovePlanSetMutation } from 'generated/graphql';

export type IFormState = {
  id: string;
};

const initialState = {
  id: ''
};

export function useFormState(id: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'Id',
        type: 'text'
      }
    }
  });

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useRemovePlanSet() {
  const [
    fnMutate,
    tuple
  ] = useRemovePlanSetMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
